import React from 'react';
import type { PdpProductInfoData } from '../../types/conciergeToolTypes';
import { getAppConsistentParams, getProductUrlV2 } from '../../../utils';
import { PdpProductInfoCard } from './PdpProductInfoCard';
import type { PdpProductCardStyles } from './pdpProductInfoCardConfig';

/**
 * PDP product card for branded apps (Product V2 catalog). The backend resolves
 * the catalog product's primary channel (the brand's own DTC store) and passes
 * its `retailerProductPageUrl` as `data.productUrl`, so the View button links
 * straight to that store.
 */
export function PdpProductInfoPartV2({
  data,
  styles,
}: {
  data: PdpProductInfoData;
  styles: PdpProductCardStyles;
}) {
  const { title, imageUrl, rating, reviewsCount, stacklineSku, productUrl } = data;

  const urlSearchParams = getAppConsistentParams(window.location.search);
  const pdpUrl = getProductUrlV2({
    title,
    stacklineSku,
    urlSearchParams,
    retailerProductPageUrl: productUrl,
  });

  return (
    <PdpProductInfoCard
      title={title}
      imageUrl={imageUrl}
      rating={rating}
      reviewsCount={reviewsCount}
      pdpUrl={pdpUrl}
      styles={styles}
    />
  );
}
